import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Link,
} from '@mui/material';
// ─── Link data ────────────────────────────────────────────────────────────────
const FOOTER_COLUMNS = [
  {
    heading: 'Product',
    links: [
      { label: 'For businesses', path: '/business' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'Contact us', path: '/contact' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Legal', path: '/legal' },
      { label: 'Privacy policy', path: '/legal/privacy' },
      { label: 'User terms', path: '/legal/terms' },
      { label: 'Business terms', path: '/legal/business-terms' },
    ],
  },
];
// ─── Component ────────────────────────────────────────────────────────────────
function Footer() {
  const navigate = useNavigate();
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        mt: 'auto',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        // Full-bleed footer band with a subtle contrast against the white page.
        background: '#f4f6f8',
      }}
    >
      {/* Main footer content (centered, page background spans full width) */}
      <Box
        sx={{
          maxWidth: 1100,
          mx: 'auto',
          px: { xs: 2, sm: 3 },
          py: { xs: 5, sm: 6 },
        }}
      >
        {/* Link columns — centered flex group so the columns stay evenly balanced
            on both mobile and web (no empty brand column pushing them off-center). */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            columnGap: { xs: 5, sm: 10 },
            rowGap: { xs: 4, sm: 0 },
          }}
        >
          {FOOTER_COLUMNS.map((col) => (
            <Box key={col.heading} sx={{ minWidth: 110, textAlign: 'center' }}>
              <Typography
                variant="overline"
                sx={{
                  fontWeight: 700,
                  fontSize: 11,
                  letterSpacing: 0.8,
                  color: 'text.disabled',
                  display: 'block',
                  mb: 1.5,
                  textAlign: 'center',
                }}
              >
                {col.heading}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
                {col.links.map((link) => (
                  <Link
                    key={link.label}
                    component="button"
                    underline="none"
                    onClick={() => navigate(link.path)}
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'text.secondary',
                      textAlign: 'center',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      p: 0,
                      transition: 'color 0.15s',
                      '&:hover': { color: 'primary.main' },
                    }}
                  >
                    {link.label}
                  </Link>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
export default Footer;
